// Kept in sync with the enums in pluginbackendnode/models/brief.js — no shared
// config layer between the two repos.
export const DELIVERABLE_TYPE_OPTIONS = [
    "Instagram",
    "Youtube",
    "Linkedin",
    "Twitter",
    "Facebook",
];

export const PRIORITY_OPTIONS = ["Low", "Medium", "High"];

// "Delayed" can be set manually here (it's a real status), but the backend's
// GET / also treats it as an automatic view — any non-Approved, non-Delayed
// brief past its deadline shows there too and gets promoted to this status.
export const STATUS_OPTIONS = ["Pending", "In Progress", "Approved", "Delayed"];
